import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LBL = {
  sk: { q: "Overenie – koľko je", a: "Odpoveď" },
  en: { q: "Verification – how much is", a: "Answer" },
  de: { q: "Verifizierung – wie viel ist", a: "Antwort" },
  pl: { q: "Weryfikacja – ile to", a: "Odpowiedź" },
  fr: { q: "Vérification – combien font", a: "Réponse" },
};

// Simple, privacy-friendly anti-bot check: a server-signed math question.
export function HumanCheck({ lang = "sk", answer, onAnswer, onToken, reloadKey = 0 }) {
  const [question, setQuestion] = useState("");
  const tx = LBL[lang] || LBL.sk;

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/human-challenge`);
        if (!active) return;
        setQuestion(data.question);
        onToken(data.token);
      } catch {
        if (active) setQuestion("?");
      }
    })();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadKey]);

  return (
    <div data-testid="human-check">
      <label className="block text-xs uppercase tracking-wider text-white/40 mb-2">
        {tx.q} <span className="text-[#D4AF37] font-semibold">{question}</span>?
      </label>
      <input
        type="text"
        inputMode="numeric"
        value={answer}
        onChange={(e) => onAnswer(e.target.value)}
        data-testid="human-check-answer"
        placeholder={tx.a}
        required
        className="w-full bg-[#050505] border border-white/15 px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#D4AF37]"
      />
    </div>
  );
}
